import { ESdChangeReason, ViewPart, Visibility } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { WorkflowProperties } from "./workflow-properties";

interface IWorkflowWindowProps {}

interface IWorkflowWindowState {
  isFrameLoading: boolean;
}

/**
 * The workflow right panel belongs to the Diagram tab only. The Diagram-tab gating now
 * lives one level up in `DesignRightPanel` (`WorkflowRightPanelTabGate`), which hides the
 * whole `.kuika_rightPanel` shell off the Diagram tab so the canvas reclaims the width —
 * this component only decides *what* to show while the panel is up.
 */
class WorkflowWindow extends PureSdComponent<
  IWorkflowWindowProps & IWithSDProps & IWithContextProp,
  IWorkflowWindowState
> {
  constructor(props: IWorkflowWindowProps & IWithSDProps & IWithContextProp) {
    super(props);
    this.state = { isFrameLoading: true };
  }

  getHeight = () => {
    if (this.props.sd.getVisibility(ViewPart.WfPropertiesPanel) === Visibility.Visible) {
      return "80px";
    }
    return "127px";
  };

  render() {
    return (
      <>
        {this.props.sd.getVisibility(ViewPart.WorkflowRightPanel) === Visibility.Visible && (
          <div style={{ width: "100%" }}>
            <div
              data-testid="workflowPropertiesPanel"
              className="kuika_workflow-properties"
              style={{ overflowY: "scroll", height: `calc(100vh - ${this.getHeight()})` }}
            >
              {this.props.sd.getVisibility(ViewPart.WfPropertiesPanel) === Visibility.Visible && (
                <WorkflowProperties key={this.props.sd.selectedWf?.id} />
              )}
            </div>
          </div>
        )}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return (
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools
    );
  };
}

const workflowWindow = withContext<IWorkflowWindowProps>(withSD<IWorkflowWindowProps>(WorkflowWindow));
export { workflowWindow as WorkflowWindow };
